export default __webpack_public_path__ + "static/media/blog-1.97a1a610.jpg";